import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";

import { useLeftnavOptions } from "../../hooks/useLeftnavOptions";
import NavLink from "../../components/Navlink/Navlink";
import NavitemExpand from "../../components/NavItemExpand/NavitemExpand";
import { ReactComponent as HomeIcon } from "../../app/assets/icons/leftnav/home-icon.svg";
import { ReactComponent as ProvisioningIcon } from "../../app/assets/icons/leftnav/provisioning-icon.svg";
import { ReactComponent as ChevroletDown } from "../../app/assets/icons/leftnav/chevrolet-down.svg";
import { ReactComponent as ChevroletUp } from "../../app/assets/icons/leftnav/chevrolet-up.svg";
import { useAppSelector } from "../../redux/store";
import "./leftnav.scss";

const iconMap: Record<string, JSX.Element> = {
  Home: <HomeIcon />,
  Provisioning: <ProvisioningIcon />,
};

const LeftNav = () => {
  const location = useLocation();

  const [expandedItem, setExpandedItem] = useState<string | null>(
    location.pathname
  );
  const { isCollapsed } = useAppSelector((state) => state.sidebar);

  const leftnavRoutes = useLeftnavOptions();

  const handleClick = (path: string, label?: string) => {
    setExpandedItem((prev) => {
      const previousPath = prev;
      if (path === previousPath || expandedItem?.includes(path)) {
        return "";
      } else {
        return path;
      }
    });
    localStorage.setItem("collapsedSecondMenu", JSON.stringify(false));
  };

  useEffect(() => {
    document
      .getElementById(location.pathname)
      ?.scrollIntoView({ block: "center" });
  }, [location.pathname, expandedItem]);

  return (
    <Nav
      className="flex-column w-100 flex-nowrap left-nav"
      style={{
        height: "fit-content",
      }}
      id="leftnav2"
    >
      {leftnavRoutes?.map((eachFirstLevelLeftnavItem) => {
        if (!eachFirstLevelLeftnavItem?.children) {
          return (
            <NavLink
              path={eachFirstLevelLeftnavItem?.path as string}
              label={eachFirstLevelLeftnavItem?.label}
              icon={iconMap[eachFirstLevelLeftnavItem?.label]}
              onClick={() => {
                handleClick(eachFirstLevelLeftnavItem?.path as string);
              }}
            />
          );
        } else {
          const expandFirstLevel =
            expandedItem === eachFirstLevelLeftnavItem?.path ||
            expandedItem?.includes(eachFirstLevelLeftnavItem?.path as string) ||
            eachFirstLevelLeftnavItem?.children?.some(
              (each) => each.path === expandedItem
            );
          return (
            <NavitemExpand
              label={eachFirstLevelLeftnavItem?.label}
              icon={iconMap[eachFirstLevelLeftnavItem?.label]}
              onClick={() => {
                handleClick(
                  eachFirstLevelLeftnavItem?.path as string,
                  eachFirstLevelLeftnavItem?.label
                );
              }}
              expandIcon={
                expandFirstLevel ? <ChevroletUp /> : <ChevroletDown />
              }
              id={eachFirstLevelLeftnavItem?.label}
            >
              {expandFirstLevel &&
                !isCollapsed &&
                eachFirstLevelLeftnavItem?.children?.map(
                  (eachSecondLevelLeftnavItem) => {
                    if (!eachSecondLevelLeftnavItem?.children) {
                      return (
                        <NavLink
                          path={eachSecondLevelLeftnavItem?.path as string}
                          label={eachSecondLevelLeftnavItem?.label}
                          className="second-level-direct-nav-item"
                        />
                      );
                    } else {
                      return <></>;
                    }
                    //  {
                    //   const baseRoute = (
                    //     eachSecondLevelLeftnavItem?.children[0].path as string
                    //   )
                    //     .split("/")
                    //     .slice(0, 3)
                    //     .join("/");
                    //   const expandSecondLevel =
                    //     expandedItem === baseRoute ||
                    //     expandedItem?.split("/").slice(0, 3).join("/") ===
                    //       baseRoute;

                    //   return (
                    //     <NavitemExpand
                    //       label={eachSecondLevelLeftnavItem?.label}
                    //       onClick={() => {
                    //         if (baseRoute === expandedItem) {
                    //           setExpandedItem(
                    //             eachFirstLevelLeftnavItem?.path as string
                    //           );
                    //         } else {
                    //           if (
                    //             expandedItem
                    //               ?.split("/")
                    //               .slice(0, 3)
                    //               .join("/") === baseRoute
                    //           ) {
                    //             setExpandedItem(
                    //               eachFirstLevelLeftnavItem?.path as string
                    //             );
                    //           } else {
                    //             setExpandedItem(baseRoute);
                    //           }
                    //         }
                    //       }}
                    //       expandIcon={
                    //         expandSecondLevel ? (
                    //           <ChevroletUp />
                    //         ) : (
                    //           <ChevroletDown />
                    //         )
                    //       }
                    //       subChildren
                    //     >
                    //       {expandSecondLevel &&
                    //         eachSecondLevelLeftnavItem?.children?.map(
                    //           (eachThirdLevelLeftnavItem) => {
                    //             const hasMethod =
                    //               "method" in eachThirdLevelLeftnavItem;
                    //             return (
                    //               <NavLink
                    //                 path={
                    //                   eachThirdLevelLeftnavItem?.path as string
                    //                 }
                    //                 className="py-1"
                    //                 label={eachThirdLevelLeftnavItem?.label}
                    //                 {...(hasMethod
                    //                   ? {
                    //                       method:
                    //                         eachThirdLevelLeftnavItem.method,
                    //                     }
                    //                   : {})}
                    //                 onClick={() =>
                    //                   handleClick(
                    //                     eachThirdLevelLeftnavItem?.path as string
                    //                   )
                    //                 }
                    //                 level="third"
                    //               />
                    //             );
                    //           }
                    //         )}
                    //     </NavitemExpand>
                    //   );
                    // }
                  }
                )}
            </NavitemExpand>
          );
        }
      })}
    </Nav>
  );
};

export default LeftNav;
